import { useEffect } from 'react';

// embed form
export const setHubspotFormIntegration = (options) => {
  const script = document.createElement('script');

  script.src = 'https://js.hsforms.net/forms/v2.js';
  script.onload = () => {
    if (window.hbspt) {
      window.hbspt.forms.create(options);
    }
  };

  document.body.appendChild(script);
};

export const HubspotFormRaw = ({
  portalId,
  formId,
  target = 'integration-hubspot',
}) => {
  useEffect(() => {
    setHubspotFormIntegration({
      portalId,
      formId,
      target: `#${target}`,
    });
  }, [formId, portalId, target]);

  return <div id={target} />;
};
